import React from 'react';
import {Checkbox, FormControlLabel} from '@mui/material';
import {styled} from '@mui/material/styles';
import {CheckboxMuiProps} from './CheckboxMuiProps';
import {FiltersCheckboxChecked, FiltersCheckboxUnChecked} from '../../icons';
import {media} from '@/styles/mediaQueries';
import LEGACY_COLORS from '@/styles/legacyColors';

const StyledFormControlLabel = styled(FormControlLabel)({
  color: LEGACY_COLORS.GRAY,
  fontSize: '16px',

  [media.mobile]: {
    marginLeft: '0',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row-reverse',
  },
});

function CheckboxMui(props: CheckboxMuiProps) {
  const {testID, label, checked, onChange, ...rest} = props;

  return (
    <StyledFormControlLabel
      control={
        <Checkbox
          {...rest}
          disableRipple
          icon={<FiltersCheckboxUnChecked />}
          checkedIcon={<FiltersCheckboxChecked />}
          onChange={onChange}
          sx={{
            '& .MuiSvgIcon-root': {
              fontSize: 25,
            },
            '&.Mui-checked': {
              color: '#000000',
            },
          }}
          data-testid={testID}
        />
      }
      label={label}
      checked={checked}
    />
  );
}

export default CheckboxMui;
